import documentService from '../services/document.service'
import i18n from '../i18n'

const state = {
  items: [],
  count: null
}

const actions = {
  getAll ({ commit }, { materialType, module, language, limit, offset }) {
    commit('getAllRequest')
    documentService.getAll({ materialType, module, language, limit, offset })
      .then(
        documents => commit('getAllSuccess', documents),
        error => commit('getAllFailure', error)
      )
  },
  getCount ({ commit }, { materialType, module, language }) {
    commit('getCountRequest')
    documentService.getCount({ materialType, module, language })
      .then(
        count => commit('getCountSuccess', count),
        error => commit('getCountFailure', error)
      )
  },
  updateSelectedByEditor ({ dispatch, commit }, { module, documentKey, materialType, language, selectedByEditor }) {
    commit('updateSelectedByEditor')
    documentService.updateSelectedByEditor({ module, documentKey, materialType, language, selectedByEditor })
      .then(
        () => {
          this._vm.$toast.open({
            type: "success",
            message: i18n.t('notification.updateSelectedByEditorSuccess')
          })
          return commit('updateSelectedByEditorSuccess', { documentKey, materialType, selectedByEditor })
        },
        error => {
          this._vm.$toast.open({
            type: "error",
            message: i18n.t('notification.updateSelectedByEditorFailure')
          })
          return commit('updateSelectedByEditorFailure', error)
        }
      )
  }
}

const mutations = {
  getCountRequest (state) {
    state = { ...state, count: null }
  },
  getCountSuccess (state, count) {
    state.count = count.count
  },
  getCountFailure (state, error) {
    state = { ...state, error }
  },
  getAllRequest (state) {
    state = { ...state, items: [], loading: true }
  },
  getAllSuccess (state, documents) {
    state.items = documents
    state.loading = false
  },
  getAllFailure (state, error) {
    state = { ...state, error }
  },
  updateSelectedByEditor (state) {
    state = { ...state, loading: true }
  },
  updateSelectedByEditorSuccess (state, { documentKey, materialType, selectedByEditor }) {
    let items = { ...state.items }
    items = state.items.map(item =>
      (item.documentKey === documentKey) ? { ...item, selectedByEditor } : item
    )
    state = {
      ...state,
      items: items
    }
  },
  updateSelectedByEditorFailure (state, { error }) {
    state = { error }
  }
}

export const documents = {
  namespaced: true,
  state,
  actions,
  mutations
}
